import { render, staticRenderFns } from "./AmountDetailPayService.vue?vue&type=template&id=57a34e96&scoped=true"
import script from "./AmountDetailPayService.vue?vue&type=script&lang=ts"
export * from "./AmountDetailPayService.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetailPayService.vue?vue&type=style&index=0&id=57a34e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a34e96",
  null
  
)

export default component.exports